<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <!-- Header Moderno -->
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Orientações</h1>
                                    <p class="modern-subtitle">Consulte nosso acervo ou crie uma nova pergunta</p>
                                </div>
                                <div class="actions-group">
                                    <div class="usage-badge" v-if="utilizacoes">
                                        <div class="badge-content">
                                            <span class="badge-label">Total de Perguntas</span>
                                            <div class="badge-numbers">
                                                <span class="number-current">{{utilizacoes.qtdRealizados}}</span>
                                                <span class="number-separator">/</span>
                                                <span class="number-total">{{utilizacoes.qtdLiberados}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div><!-- modern-header -->
                    <div class="table-container">
                        <div class="table-wrapper">
                            <div class="custom-table-header bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100">
                                <button @click="abrirModalNovaPergunta"
                                        class="modern-btn modern-btn-primary"
                                        v-if="utilizacoes && utilizacoes.permiteRealizarPerguntas">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    Nova pergunta
                                </button>
                                <div class="search-box">
                                    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>
                                    <input v-model="busca" type="text" class="modern-search-input" placeholder="Buscar nas perguntas">
                                </div>
                                <ManualFerramenta :name="'Manual Orientações'"
                                                  :btnClass="'btn-manual-tool'"
                                                  :nameBtn="'Manual'"
                                                  :urlPdf="'/manuais/FERRAMENTA ORIENTACOES PDF.pdf'" />
                            </div> <!-- custom-table-header -->
                            <!-- Estado Vazio -->
                            <div class="empty-state" v-if="orientacoes != null && orientacoes.length == 0">
                                <div class="empty-content">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                    <h3 class="empty-title">Nenhuma pergunta encontrada!</h3>
                                    <p class="empty-description">Crie sua primeira pergunta para começar</p>
                                </div>
                            </div>

                            <!-- Cards de Orientação -->
                            <div class="orientacoes-grid" v-else>
                                <div class="orientacao-card" :class="{ 'orientacao-card--outro-contrato': isContratoDiferente(item) }" v-for="(item) in orientacoes" :key="item.idPergunta">
                                    <div class="card-body">
                                        <div class="card-header">
                                            <h3 class="card-title">{{item.dsAssunto}}</h3>
                                        </div>

                                        <div class="card-divider"></div>

                                        <div class="card-info-grid">
                                            <div class="info-item">
                                                <div class="info-icon">
                                                    <i class="fas fa-calendar-alt"></i>
                                                </div>
                                                <div class="info-label">Solicitado</div>
                                                <div class="info-value">{{item.dtPerguntaFormat}}</div>
                                            </div>
                                            <div class="info-item">
                                                <div class="info-icon">
                                                    <i class="fas fa-hourglass"></i>
                                                </div>
                                                <div class="info-label">
                                                    <span v-if="item.perguntaEtapa.nmEtapa == 'Finalizada' || item.perguntaEtapa.nmEtapa == 'Cancelada'">Previsto</span>
                                                    <span v-else>Conclusão prevista</span>
                                                </div>
                                                <div class="info-value">
                                                    <span v-if="item.dtPrazo == null && item.perguntaEtapa.nmEtapa == 'Complemento'">Aguardando</span>
                                                    <span v-else>{{item.dtPrazoFormat}}</span>
                                                </div>
                                            </div>
                                            <div class="info-item">
                                                <div class="info-icon">
                                                    <i class="fas fa-calendar-check" v-if="item.perguntaEtapa.nmEtapa == 'Finalizada' || item.perguntaEtapa.nmEtapa == 'Cancelada'"></i>
                                                    <i class="fas fa-calendar" v-else></i>
                                                </div>
                                                <div class="info-label">
                                                    <span v-if="item.perguntaEtapa.nmEtapa == 'Finalizada' || item.perguntaEtapa.nmEtapa == 'Cancelada'">Finalizado</span>
                                                    <span v-else>última interação</span>
                                                </div>
                                                <div class="info-value">{{item.dtMovimento}}</div>
                                            </div>
                                        </div>

                                        <div class="card-divider"></div>

                                        <!-- Status -->
                                        <div class="status-container" v-if="item.perguntaEtapa.nmEtapa == 'Abertura' || item.perguntaEtapa.nmEtapa == 'Andamento' || item.perguntaEtapa.nmEtapa == 'Encaminhada'">
                                            <div class="status-badge status-waiting">
                                                <i class="fas fa-hourglass"></i>
                                                <span>Aguardando atendimento</span>
                                            </div>
                                            <p class="status-description">Sua pergunta foi encaminhada para a nossa equipe, e está em processo de atendimento.</p>
                                        </div>

                                        <div class="status-container" v-else-if="item.perguntaEtapa.nmEtapa == 'Iniciada'">
                                            <div class="status-badge status-waiting">
                                                <i class="fas fa-hourglass"></i>
                                                <span>Aguardando resposta</span>
                                            </div>
                                            <p class="status-description">Sua pergunta foi encaminhada para a nossa equipe, e está em processo de atendimento.</p>
                                        </div>

                                        <div class="status-container" v-else-if="item.perguntaEtapa.nmEtapa == 'Complemento'">
                                            <div class="status-badge status-pending piscando">
                                                <i class="fa fa-reply"></i>
                                                <span>Aguardando Retorno</span>
                                            </div>
                                            <p class="status-description">Necessitamos que sua pergunta seja complementada para melhor atendimento de nossa equipe, Por favor complemente sua pergunta.</p>
                                        </div>

                                        <div class="status-container" v-else-if="item.perguntaEtapa.nmEtapa == 'Finalizada'">
                                            <div class="status-badge status-success">
                                                <i class="fas fa-envelope"></i>
                                                <span>Respondido</span>
                                            </div>
                                            <p class="status-description">Sua pergunta foi respondida! Clique em <strong>Visualizar Informações</strong> para ter acesso a resposta.</p>
                                        </div>

                                        <div class="status-container" v-else-if="item.perguntaEtapa.nmEtapa == 'Cancelada'">
                                            <div class="status-badge status-error">
                                                <i class="fas fa-times"></i>
                                                <span>Cancelado</span>
                                            </div>
                                            <p class="status-description">Sua pergunta foi cancelada. Por favor, verifique o motivo clicando em <strong>Visualizar Informações</strong>.</p>
                                        </div>

                                        <div class="status-container" v-else-if="item.perguntaEtapa.nmEtapa == 'Processando'">
                                            <div class="status-badge status-waiting">
                                                <i class="fas fa-hourglass"></i>
                                                <span>Processando resposta por IA</span>
                                            </div>
                                            <p class="status-description">Sua pergunta foi encaminhada para processamento a nossa IA, dentro de alguns minutos sua resposta estará disponível.</p>
                                        </div>

                                        <div class="status-container" v-else-if="item.perguntaEtapa.nmEtapa == 'Processado'">
                                            <div class="status-badge status-success">
                                                <i class="fas fa-hourglass"></i>
                                                <span>Respondida por IA</span>
                                            </div>
                                            <p class="status-description">Sua pergunta foi respondida por nossa IA! Clique em <strong>Visualizar Informações</strong> para ter acesso a resposta.</p>
                                        </div>

                                        <div class="status-container" v-else-if="item.perguntaEtapa.nmEtapa == 'Finalizada Usuário'">
                                            <div class="status-badge status-success">
                                                <i class="fas fa-envelope"></i>
                                                <span>Finalizada pelo Usuário</span>
                                            </div>
                                            <p class="status-description">Sua pergunta foi finalizada. Clique em <strong>Visualizar Informações</strong> para ter acesso a resposta.</p>
                                        </div>

                                        <div class="status-container" v-else>
                                            <div class="status-badge status-default">
                                                <i class="fas fa-sync-alt"></i>
                                                <span>Sem dados</span>
                                            </div>
                                            <p class="status-description">Não foi possível carregar sua pergunta, entre em contato com o suporte para mais informações.</p>
                                        </div>
                                    </div>
                                    <div class="card-footer" @click="detalhes(item.idPergunta)">
                                        <i class="fas fa-eye"></i>
                                        <span>Visualizar informações</span>
                                    </div>
                                </div>
                            </div>
                            <div class="custom-table-footer bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100" v-if="utilizacoes != null">
                                <div class="usage-info-footer">
                                    <span class="usage-text">
                                        Total de perguntas realizadas: <strong>{{utilizacoes.qtdRealizadosTotal}}</strong>
                                    </span>
                                    <span class="usage-text">
                                        Durante o contrato vigente: <strong>{{utilizacoes.qtdRealizados}}</strong> de <strong>{{utilizacoes.qtdLiberados}}</strong>
                                    </span>
                                </div>
                            </div> <!-- custom-table-footer -->
                        </div><!-- table-wrapper -->
                    </div><!-- table-container -->
                </div><!-- tyn-section -->
                <!-- MODAL NOVA PERGUNTA -->
            </div>
        </div>

        <div class="modal fade modern-modal" id="ModalNovaOrientacao" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            @click="fecharModalNovaPergunta">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Nova pergunta</h2>
                            <p>Preencha todos os campos para registrar sua solicitação de orientação.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <form id="formNovaOrientacao" @submit.prevent="enviar">
                            <!-- 1. Tipo de pergunta -->
                            <div class="form-group">
                                <label class="form-label">1. Selecione a modalidade da orientação que gostaria de receber:</label>
                                <div class="tipo-pergunta-grid">
                                    <div v-for="item in lstTipoPergunta" :key="item.idTipoPergunta"
                                         :class="['tipo-pergunta-card', { 'selected': novaOrientacao.idTipoPergunta === item.idTipoPergunta }]"
                                         @click="selecionaTipoPergunta(item.idTipoPergunta)">
                                        <i :class="item.icone"></i>
                                        <span class="tipo-nome">{{ item.nmTipoPergunta }}</span>
                                        <span class="tipo-prazo">
                                            <template v-if="item.hrPrazo > 0">
                                                {{ item.hrPrazo }} horas úteis
                                            </template>
                                            <template v-else>
                                                Imediato
                                            </template>
                                        </span>
                                    </div>
                                </div>

                                <!-- Mensagens de aviso por tipo -->
                                <div class="mensagem-tipo" v-if="novaOrientacao.idTipoPergunta">
                                    <div class="mensagem-aviso mensagem-estudo" v-if="showMsgEstudo">
                                        * Poderão ser formulados no máximo 04 (quatro) questionamentos/perguntas/pedidos de esclarecimentos, a cada Estudo técnico solicitado. Perguntas excedentes serão considerados um novo e independente Estudo Técnico.<br />
                                        * O prazo será definido após envio para o consultor
                                    </div>
                                    <div class="mensagem-aviso mensagem-resposta" v-if="showMsgResposta">
                                        * Poderão ser formulados no máximo 02 (dois) questionamentos/perguntas/pedidos de esclarecimentos, a cada Resposta Objetiva solicitada. Perguntas excedentes serão consideradas uma nova e independente Resposta Objetiva.<br />
                                        * O prazo será definido após envio para o consultor
                                    </div>
                                    <div class="mensagem-aviso mensagem-mentoria" v-if="showMsgMentoria">
                                        * A Mentoria online consiste na prestação de serviços de capacitação interativa em matéria de Licitações e Contratos, a ser realizada por meio da plataforma Zoom.<br />
                                        *** Por ocasião da formulação da demanda, deverão ser pontualmente delimitadas as temáticas a serem abrangidas pela mentoria.
                                    </div>
                                    <div class="mensagem-aviso mensagem-whats" v-if="showMsgWhats">
                                        * A orientação via WhatsApp/Áudio será procedida por meio de áudio, a ser disponibilizado à Contratante via sistema para registro.
                                    </div>
                                    <div class="mensagem-aviso mensagem-telefonico" v-if="showMsgTelefonico">
                                        * O contato telefônico destina-se à resolução de questões pontuais e urgentes. <br />
                                        *** segunda a quinta-feira, das 9h às 12h e das 13h às 17h; e sextas-feiras das 9h às 12h.
                                    </div>
                                </div>
                            </div>

                            <div class="formulario-orientacao"
                                 :class="{ 'formulario-orientacao--travado': !formularioLiberado }">
                                <p class="formulario-orientacao-hint" v-if="!formularioLiberado">
                                    Selecione uma modalidade de orientação acima para liberar o restante do formulário.
                                </p>

                                <!-- 2. Telefone -->
                                <fieldset :disabled="!formularioLiberado" class="formulario-orientacao-fields">
                                    <div class="form-group">
                                        <label class="form-label">2. Telefone para contato:</label>
                                        <input type="tel"
                                               class="form-control"
                                               v-model="novaOrientacao.nrTelefoneContato"
                                               @input="aplicarMascaraTelefone"
                                               placeholder="(xx) xxxxx-xxxx"
                                               maxlength="15"
                                               required>
                                    </div>

                                    <!-- 3. Assunto -->
                                    <div class="form-group">
                                        <label class="form-label">3. Sua pergunta é sobre qual tema ou assunto?</label>
                                        <input type="text"
                                               class="form-control"
                                               id="dsAssunto"
                                               placeholder="Digite o tema ou assunto da pergunta"
                                               v-model="novaOrientacao.dsAssunto"
                                               maxlength="100"
                                               required>
                                    </div>

                                    <!-- 4. Descrição -->
                                    <div class="form-group">
                                        <label class="form-label">4. Descrição da sua pergunta:</label>
                                        <div class="textarea-com-contador">
                                            <textarea class="form-control form-textarea"
                                                      id="dsPergunta"
                                                      rows="5"
                                                      placeholder="Descreva sua pergunta"
                                                      v-model="novaOrientacao.dsPergunta"
                                                      :maxlength="temLimiteCaracteres ? limiteCaracteres : null"
                                                      :class="{ 'form-textarea--excedido': descricaoExcedeLimite }"
                                                      required></textarea>
                                            <div class="char-counter" v-if="temLimiteCaracteres">
                                                <span class="char-count-text"
                                                      :class="{ 'char-count-text--excedido': descricaoExcedeLimite }">
                                                    {{ qtdCaracteresDescricao }}/{{ limiteCaracteres }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 5. Arquivos-->
                                    <div class="form-group" v-if="nmTipoPergunta == 'Resposta Objetiva' || nmTipoPergunta == 'Estudo Técnico'">
                                        <label class="form-label">5. Documentos da sua pergunta:</label>
                                        <AvisoUploadDocumentos></AvisoUploadDocumentos>
                                        <p>Selecione até 2 arquivos, <span id="negrito">word</span> ou <span id="negrito">pdf</span>.</p>

                                        <ImputUploadS3 :reset="resetUpload" :labelText="'Selecionar Arquivos'" @onSave="setUploadFile" @onDelete="deleteUploadFile" :destino="'PerguntaDocumento'" :multiple="true" :id="'input_file_orientacao'" :maxFiles="2" :whoFiles="'.pdf,.doc,.docx'"></ImputUploadS3>
                                    </div>

                                </fieldset>
                            </div>
                        </form>
                    </div>
                    <!-- Botão enviar -->
                    <div class="modal-modern-footer">
                        <button class="btn btn-modern-primary w-100"
                                type="submit"
                                form="formNovaOrientacao"
                                :disabled="!validaOrientacao"
                                v-if="!utilizacoes || !utilizacoes.flCortesia">
                            Enviar pergunta
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade modern-modal" id="ModalAvisoRecesso" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            @click="fecharModalAvisoRecesso">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <i class="fas fa-exclamation-triangle fa-2x"></i>
                        </div>
                        <div class="header-text">
                            <h2>Aviso</h2>
                            <p>
                                Fique atento às datas de início e término do recesso de fim de ano.
                            </p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="row mt-3">

                            <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                                Recesso fim de ano 2025
                            </p>
                            <br />
                            <br />
                            <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                                Prezados Solicitantes
                            </p>
                            <br />
                            <br />
                            <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                                Informamos que o setor Jurídico do Sollicita/SollAi entrará em recesso no dia <span class="txt-w-bold">23/12/25</span> (23 de Dezembro de 2025), retornando as suas atividades em <span class="txt-w-bold">07/01/26</span> (7 de Janeiro de 2026).
                            </p>
                            <br />
                            <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                                Durante o referido período não serão prestados atendimentos nem computados prazos, conforme previsto pelo Método de Trabalho.
                            </p>
                            <br />
                            <br />
                            <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                                Aproveitamos a oportunidade para desejar a todos um Feliz Natal e um 2026 de muito sucesso!
                            </p>
                            <br />
                            <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                                Cordialmente,
                            </p>
                            <br />
                            <p class="txt-p txt-size-16 txt-w-5 txt-cores-6">
                                Equipe Técnica
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAIS HEADER -->
        <Modais></Modais>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import Modais from '@/components/Modais'
    import ImputUploadS3 from '@/components/Input_Upload_s3'
    import AvisoUploadDocumentos from '@/components/AvisoUploadDocumentos'
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta'

    export default {
        name: 'Orientacao',
        components: { Header, Modais, ImputUploadS3, AvisoUploadDocumentos, ManualFerramenta },
        data: function () {
            return {
                orientacoes: null,
                utilizacoes: null,
                showModal: false,
                termo: '',
                loading: null,
                busca: '',
                lstTipoPergunta: [],
limiteCaracteres: 8000,
                showQuantidadeCaracteres: false,
                novaOrientacao: {
                    idTipoPergunta: null,
                    nrTelefoneContato: '',
                    dsAssunto: null,
                    dsPergunta: null,
                },
                showMsgEstudo: false,
                showMsgResposta: false,
                showMsgMentoria: false,
                showMsgWhats: false,
                showMsgTelefonico: false,
                options: {
                    placeholder: 'Digite o número com o DDD',
                },
                dataAtual: moment(),
                nmTipoPergunta: null,

                resetUpload: false,
                files: null,
            }
        },

        computed: {
            user() {
                return this.$store.state.user;
            },
            formularioLiberado() {
                return !!this.novaOrientacao.idTipoPergunta;
            },
            qtdCaracteresDescricao() {
                return (this.novaOrientacao.dsPergunta || '').length;
            },
            temLimiteCaracteres() {
                return this.limiteCaracteres !== '' && this.limiteCaracteres !== null && this.limiteCaracteres > 0;
            },
            descricaoExcedeLimite() {
                return this.temLimiteCaracteres && this.qtdCaracteresDescricao > this.limiteCaracteres;
            },
            validaOrientacao() {
                if (!this.formularioLiberado) return false;
                if (!this.novaOrientacao.nrTelefoneContato) return false;
                if (!this.novaOrientacao.dsAssunto) return false;
                if (!this.novaOrientacao.dsPergunta) return false;
                if (this.descricaoExcedeLimite) return false;
                return true;
            }
        },

        watch: {
            busca: {
                handler() {
                    clearTimeout(this.debounceTimeout);
                    this.debounceTimeout = setTimeout(() => {
                        this.load();
                    }, 500);
                }
            }
        },

        methods: {
            isContratoDiferente(item) {
                const idAtual = this.user?.usuario?.idContrato;
                if (idAtual == null || item?.idContrato == null) return false;
                return Number(item.idContrato) !== Number(idAtual);
            },

            detalhes(id) {
                this.$router.push({ name: 'Detalheorientacao', params: { id: id } })
            },

            pesquisa() {
                if (!this.busca || this.busca.trim() === '') return;
                this.load();
            },

            load() {
                this.loading = this.$loading.show({});
                let $this = this;
                axios.get(`${urlApi}/Pergunta/Get`, { showLoading: false, params: { termo: $this.busca } })
                    .then(res => {
                        if (res.data.success) {
                            $this.orientacoes = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];
                                item.dtPerguntaFormat = moment(item.dtPergunta).format('DD/MM/YYYY [às] HH:mm');
                                if (item.dtPrazo) {
                                    item.dtPrazoFormat = moment(item.dtPrazo).format('DD/MM/YYYY [às] HH:mm');
                                } else {
                                    item.dtPrazoFormat = '-';
                                }
                                
                                if (item.perguntaMovimento != null) {
                                    item.dtMovimento = moment(item.perguntaMovimento.dtMovimento).format('DD/MM/YYYY [às] HH:mm');
                                } else {
                                    item.dtMovimento = null;
                                }

                                $this.orientacoes.push(item);
                            }

                        } else {
                            avisoErro("Não foi possível carregar suas orientações.");
                        }

                        $this.carregaUtilizacoes();
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/Pergunta/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {

                            $this.utilizacoes = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar suas orientações.");
                        }
                        $this.loading.hide();
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            showAvisoRecesso() {
                const el = document.getElementById('ModalAvisoRecesso');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    const modal = new bs.Modal(el);
                    modal.show();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal({ backdrop: 'static', keyboard: false, show: true });
                }
            },
            fecharModalAvisoRecesso(){
                const el = document.getElementById('ModalAvisoRecesso');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    const instance = bs.Modal.getInstance(el);
                    if (instance) instance.hide();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('hide');
                }
            },

            abrirModalNovaPergunta() {
                // reseta campos
                this.novaOrientacao = {
                    idTipoPergunta: null,
                    nrTelefoneContato: '',
                    dsAssunto: null,
                    dsPergunta: null,
                };
this.limiteCaracteres = 8000;
                this.showQuantidadeCaracteres = false;
                this.showMsgEstudo = false;
                this.showMsgResposta = false;
                this.showMsgMentoria = false;
                this.showMsgWhats = false;
                this.showMsgTelefonico = false;
                this.nmTipoPergunta = null;
                this.resetUpload = !this.resetUpload;

                const el = document.getElementById('ModalNovaOrientacao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    const modal = new bs.Modal(el);
                    modal.show();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal({ backdrop: 'static', keyboard: false, show: true });
                }
            },

            fecharModalNovaPergunta() {
                const el = document.getElementById('ModalNovaOrientacao');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    const instance = bs.Modal.getInstance(el);
                    if (instance) instance.hide();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('hide');
                }
            },

            async enviar() {
                if (!this.formularioLiberado) {
                    avisoToast('Selecione uma modalidade de orientação para continuar.', 'warning');
                    return;
                }
                if (!this.checkForm()) return;

                this.novaOrientacao.files = [];
                if (this.files != null) {
                    for (let i = 0; i < this.files.length; i++) {
                        this.novaOrientacao.files.push(this.files[i].key);
                    }
                }               

                try {
                    const res = await axios.post(`${urlApi}/Pergunta/`, this.novaOrientacao);

                    if (res.data && res.data.success) {
                        avisoToast("Sua solicitação de Orientação foi registrada com sucesso!", "success");
                        this.fecharModalNovaPergunta();
                        if (res.data.msg) {
                            this.detalhes(parseInt(res.data.msg))
                        }
                        
                        this.load(); // recarrega lista e utilizações
                    } else {
                        avisoErro(res.data?.msg || "Não foi possível realizar seu cadastro.");
                    }
                } catch (res) {
                    if (res.response?.data !== undefined) {
                        avisoErro(res.response.data);
                    } else {
                        avisoErro(res.response?.statusText || "Erro ao enviar pergunta.");
                    }
                }
            },

            checkForm() {
                const form = document.getElementById('formNovaOrientacao');
                if (!form) return false;

                if (!form.checkValidity()) {
                    const tmpSubmit = document.createElement('button');
                    form.appendChild(tmpSubmit);
                    tmpSubmit.click();
                    form.removeChild(tmpSubmit);
                    return false;
                }

                if (this.descricaoExcedeLimite) {
                    avisoErro(`Para esta modalidade a descrição deverá ter no máximo ${this.limiteCaracteres} caracteres.`);
                    return false;
                }

                return true;
            },

            selecionaTipoPergunta(idTipoPergunta) {
                const tipoPergunta = this.lstTipoPergunta.find(x => x.idTipoPergunta === idTipoPergunta);
                if (!tipoPergunta) return;

                if (tipoPergunta.nmTipoPergunta.includes('Atendimento Telefônico')) {
                    if (!this.validaHorarioAtendimentoTelefonico()) {
                        avisoToast(
                            'O Atendimento Telefônico está disponível de segunda a quinta-feira, das 9h às 12h e das 13h às 17h, e sextas-feiras das 9h às 12h.',
                            'warning'
                        );
                        return;
                    }
                }

                const novoLimite = (
                    tipoPergunta.qtdCaracteresPergunta === 0
                        ? ""
                        : tipoPergunta.qtdCaracteresPergunta
                );

                this.limiteCaracteres = novoLimite;
                this.novaOrientacao.idTipoPergunta = idTipoPergunta;
                this.nmTipoPergunta = tipoPergunta.nmTipoPergunta;

                this.showMsgEstudo = tipoPergunta.nmTipoPergunta.includes('Estudo Técnico');
                this.showMsgResposta = tipoPergunta.nmTipoPergunta.includes('Resposta Objetiva');
                this.showMsgMentoria = tipoPergunta.nmTipoPergunta.includes('Mentoria Online');
                this.showMsgTelefonico = tipoPergunta.nmTipoPergunta.includes('Atendimento Telefônico');
                this.showMsgWhats = tipoPergunta.nmTipoPergunta.includes('Atendimento via WhatsApp');

                if (novoLimite !== '' && this.qtdCaracteresDescricao > novoLimite) {
                    avisoToast(
                        `Para esta modalidade a descrição deverá ser menor (máximo de ${novoLimite} caracteres). Reduza o texto para continuar.`,
                        'warning'
                    );
                }
            },

            validaHorarioAtendimentoTelefonico() {
                this.dataAtual = moment();
                const diaSemana = this.dataAtual.day();
                const hora = this.dataAtual.hour();

                const periodoManha = hora >= 9 && hora < 12;
                const periodoTarde = hora >= 13 && hora < 17;

                if (diaSemana >= 1 && diaSemana <= 4) {
                    return periodoManha || periodoTarde;
                }

                if (diaSemana === 5) {
                    return periodoManha;
                }

                return false;
            },

            carregarTiposPerguntas() {
                let $this = this;
                axios.get(`${urlApi}/TipoPerguntaOrientacao/Get?flAtivo=true`, { showLoading: false })
                    .then(res => {
                        if (res.data.success) {
                            const rows = res.data.data.rows || [];
                            $this.lstTipoPergunta = rows.map(tp => ({
                                ...tp,
                                icone: $this.getIconeTipoPergunta(tp.nmTipoPergunta)
                            }));
                        } else {
                            avisoErro("Não foi possível carregar as modalidades de orientação.");
                        }
                    })
                    .catch(res => {
                        if (res.response?.data !== undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response?.statusText || "Erro ao carregar as modalidades de orientação.");
                        }
                    });
            },

            getIconeTipoPergunta(nmTipoPergunta) {
                switch (nmTipoPergunta) {
                    case 'Estudo Técnico':
                        return 'fas fa-clipboard-list';
                    case 'Resposta Objetiva':
                        return 'far fa-clock';
                    case 'Atendimento Telefônico':
                        return 'fas fa-phone-alt';
                    case 'Atendimento via WhatsApp':
                        return 'fab fa-whatsapp';
                    case 'Mentoria Online':
                        return 'fas fa-laptop';
                    default:
                        return '';
                }
            },

            aplicarMascaraTelefone(event) {
                let valor = event.target.value;
                valor = valor.replace(/\D/g, '');
                if (valor.length <= 2) {
                    this.novaOrientacao.nrTelefoneContato = valor;
                } else if (valor.length <= 6) {
                    this.novaOrientacao.nrTelefoneContato = `(${valor.substring(0, 2)}) ${valor.substring(2)}`;
                } else if (valor.length <= 10) {
                    // Telefone com 8 dígitos (formato: (xx) xxxx-xxxx)
                    this.novaOrientacao.nrTelefoneContato = `(${valor.substring(0, 2)}) ${valor.substring(2, 6)}-${valor.substring(6)}`;
                } else {
                    // Telefone com 9 dígitos (formato: (xx) xxxxx-xxxx)
                    this.novaOrientacao.nrTelefoneContato = `(${valor.substring(0, 2)}) ${valor.substring(2, 7)}-${valor.substring(7, 11)}`;
                }
            },

            setUploadFile(lstFiles) {
                if (lstFiles == null || lstFiles === '') {
                    return;
                }
                if (this.files == null) {
                    this.files = [];
                }
                const items = Array.isArray(lstFiles) ? lstFiles : [lstFiles];
                for (let i = 0; i < items.length; i++) {
                    if (!this.files.some(f => f.key === items[i].key)) {
                        this.files.push(items[i]);
                    }
                }
            },

            deleteUploadFile(hash) {
                this.files = this.files.filter(function (obj) { return obj.hash !== hash });
            },

        },
        mounted: function () {
            this.busca = this.termo;
            this.load();

            this.carregarTiposPerguntas();
            axios.post(`${urlApi}/Log/AcessoProduto`, { 'cdProduto': 'SO' });

            let $this = this;            
            let hoje = moment();
            if (hoje >= moment('2025-12-21') && hoje < moment('2026-01-08 09:00:00')) {
                setTimeout(function () {
                    $this.showAvisoRecesso();
                }, 1000);
            }
        }
    };
</script>

<style scoped>
    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

        .modern-header .container {
            max-width: none !important;
        }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        flex: 0 0 auto;
        text-align: left;
        max-width: 500px;
        min-width: 200px;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .actions-group {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    .usage-badge {
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #3b82f6;
        border-radius: 16px;
        padding: 20px 32px;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
        min-width: 200px;
        margin-right: 12px;
    }

    [data-bs-theme="dark"] .usage-badge {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
    }

    .badge-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    .badge-label {
        font-size: 13px;
        font-weight: 600;
        color: #3b82f6;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        text-align: center;
    }

    [data-bs-theme="dark"] .badge-label {
        color: #93c5fd;
    }

    .badge-numbers {
        display: flex;
        align-items: baseline;
        gap: 4px;
        font-weight: 700;
    }

    .number-current {
        font-size: 24px;
        color: #1f2937;
    }

    [data-bs-theme="dark"] .number-current {
        color: #f9fafb;
    }

    .number-separator {
        font-size: 20px;
        color: #9ca3af;
        margin: 0 4px;
    }

    .number-total {
        font-size: 22px;
        color: #10b981;
        font-weight: 800;
    }

    .table-container {
        display: flex;
        justify-content: center;
        padding-top: 22px;
        padding-bottom: 0px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .table-wrapper {
        width: 100%;
        padding: 0 10px;
        margin: 0 auto;
        overflow-x: auto;
        min-height: 700px;
    }

    .custom-table-header {
        background: linear-gradient(to bottom, #ffffff 0%, #fafafa 100%);
        border: 1px solid #e5e7eb;
        border-bottom: none;
        border-radius: 12px 12px 0 0;
        padding: 16px 20px;
        display: flex;
        align-items: center;
        gap: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    [data-bs-theme="dark"] .custom-table-header {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .search-box {
        position: relative;
        flex: 1;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        width: 100%;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
    }

        .modern-search-input:focus {
            outline: none;
            border-color: #2563eb;
            background: white;
            box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
        }

    [data-bs-theme="dark"] .modern-search-input {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .modern-search-input:focus {
            background: #111827;
            border-color: #3b82f6;
        }

    [data-bs-theme="dark"] .modern-search-input::placeholder {
        color: #6b7280;
    }

    .custom-table-footer {
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0 0 12px 12px;
        padding: 16px 20px;
        display: flex;
        justify-content: center;
        font-family: 'Segoe UI';
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .custom-table-footer {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .usage-info-footer {
        display: flex;
        flex-direction: column;
        gap: 8px;
        text-align: center;
    }

    .usage-text {
        font-size: 14px;
        color: #6b7280;
    }

    [data-bs-theme="dark"] .usage-text {
        color: #9ca3af;
    }

    .usage-text strong {
        color: #1f2937;
        font-weight: 700;
    }

    [data-bs-theme="dark"] .usage-text strong {
        color: #f9fafb;
    }

    /* Botões Modernos */
    .modern-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        min-height: 40px;
        position: relative;
        overflow: hidden;
    }

        .modern-btn::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 220%;
            height: 220%;
            border-radius: 50%;
            background: rgba(255,255,255,0.30);
            transform: translate(-50%, -50%) scale(0);
            transition: transform .6s ease;
            pointer-events: none;
        }

        .modern-btn:hover::before {
            transform: translate(-50%, -50%) scale(1);
        }

        .modern-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(31, 123, 255, 0.3);
        }

        .modern-btn:active {
            transform: translateY(0);
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

        .modern-btn-primary:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        }

    .modern-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none !important;
    }

    /* Grid de Orientações */
    .orientacoes-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
        gap: 20px;
        padding: 20px;
        background: white;
        border: 1px solid #e5e7eb;
        border-top: none;
        border-bottom: none;
    }

    [data-bs-theme="dark"] .orientacoes-grid {
        background: #1f2937;
        border-color: #374151;
    }

    @media (max-width: 768px) {
        .orientacoes-grid {
            grid-template-columns: 1fr;
        }
    }

    /* Cards de Orientação */
    .orientacao-card {
        background: white;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid #e5e7eb;
        display: flex;
        flex-direction: column;
        min-height: 400px;
        height: 100%;
    }

    [data-bs-theme="dark"] .orientacao-card {
        background: #1f2937;
        border-color: #374151;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    }

    .orientacao-card--outro-contrato {
        background: #f3f4f6;
    }

    [data-bs-theme="dark"] .orientacao-card--outro-contrato {
        background: #374151;
    }

    .orientacao-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }

    [data-bs-theme="dark"] .orientacao-card:hover {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
    }

    .card-body {
        padding: 16px;
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .card-header {
        margin-bottom: 2px;
        min-height: 50px;
    }

    .card-title {
        font-size: 15px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    [data-bs-theme="dark"] .card-title {
        color: #f9fafb;
    }

    .card-divider {
        height: 1px;
        background: linear-gradient(90deg, transparent, #e5e7eb 20%, #e5e7eb 80%, transparent);
        margin: 12px 0;
    }

    [data-bs-theme="dark"] .card-divider {
        background: linear-gradient(90deg, transparent, #374151 20%, #374151 80%, transparent);
    }

    .card-info-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        margin-bottom: 12px;
    }

    .info-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .info-icon {
        font-size: 20px;
        color: #2563eb;
        margin-bottom: 6px;
    }

    [data-bs-theme="dark"] .info-icon {
        color: #60a5fa;
    }

    .info-label {
        font-size: 11px;
        font-weight: 500;
        color: #6b7280;
        margin-bottom: 3px;
        min-height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    [data-bs-theme="dark"] .info-label {
        color: #9ca3af;
    }

    .info-value {
        font-size: 12px;
        font-weight: 700;
        color: #1f2937;
    }

    [data-bs-theme="dark"] .info-value {
        color: #f9fafb;
    }

    /* Status */
    .status-container {
        margin-top: 12px;
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .status-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 12px;
        border-radius: 8px;
        font-weight: 600;
        font-size: 13px;
        margin-bottom: 8px;
        width: 100%;
        justify-content: center;
    }
    
    .status-badge i {
        font-size: 14px;
    }

    .status-waiting {
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        color: #92400e;
    }

    .status-pending {
        background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
        color: #1e40af;
    }

    .status-success {
        background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
        color: #065f46;
    }

    .status-error {
        background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
        color: #991b1b;
    }

    .status-default {
        background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
        color: #374151;
    }

    /* Dark Mode - Status Badges */
    [data-bs-theme="dark"] .status-waiting {
        background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
        color: #fef3c7;
    }

    [data-bs-theme="dark"] .status-pending {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
        color: #dbeafe;
    }

    [data-bs-theme="dark"] .status-success {
        background: linear-gradient(135deg, #065f46 0%, #047857 100%);
        color: #d1fae5;
    }

    [data-bs-theme="dark"] .status-error {
        background: linear-gradient(135deg, #991b1b 0%, #b91c1c 100%);
        color: #fee2e2;
    }

    [data-bs-theme="dark"] .status-default {
        background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        color: #e5e7eb;
    }

    .piscando {
        animation: piscar 1.5s infinite;
    }

    @keyframes piscar {
        0%, 100% {
            opacity: 1;
        }

        50% {
            opacity: 0.6;
        }
    }

    .status-description {
        font-size: 12px;
        color: #6b7280;
        line-height: 1.4;
        margin: 0;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    [data-bs-theme="dark"] .status-description {
        color: #9ca3af;
    }

    .status-description strong {
        font-weight: 700;
        color: #1f2937;
    }

    [data-bs-theme="dark"] .status-description strong {
        color: #f9fafb;
    }

    /* Footer do Card */
    .card-footer {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
        padding: 12px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        font-weight: 600;
        font-size: 13px;
        margin-top: auto;
        flex-shrink: 0;
    }
    
    .card-footer i {
        font-size: 14px;
    }

        .card-footer:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        }

    /* Estado Vazio */
    .empty-state {
        padding: 80px 20px !important;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        border: 1px solid #e5e7eb;
        border-top: none;
        border-radius: 0;
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        animation: fadeInUp 0.5s ease-out;
    }

    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .empty-icon {
        color: #cbd5e1;
        margin-bottom: 8px;
    }

    [data-bs-theme="dark"] .empty-icon {
        color: #475569;
    }

    .empty-title {
        font-size: 24px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-title {
        color: #f9fafb;
    }

    .empty-description {
        font-size: 16px;
        color: #6b7280;
        margin: 0;
    }

    [data-bs-theme="dark"] .empty-description {
        color: #9ca3af;
    }

    /* Textos utilitários */
    .txt-cores-6 {
        color: #1f2937;
    }

    [data-bs-theme="dark"] .txt-cores-6 {
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .txt-w-bold {
        color: #f9fafb;
    }

    /* Modal Moderno */
    .btn-md{
        z-index: 1000;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-close-modern:hover {
            transform: scale(1.07);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
            border-color: transparent !important;
        }

            .btn-close-modern:hover svg {
                color: #ffffff;
            }
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

        .modal-modern-header .header-icon {
            width: 64px;
            height: 64px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
            color: #2563eb;
        }

        .modal-modern-header .header-text h2 {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
            color: #0f172a;
        }

        .modal-modern-header .header-text p {
            margin-top: 6px;
            margin-bottom: 0;
            color: #475569;
            font-size: 14px;
            max-width: 420px;
            line-height: 1.4;
        }

    .modal-modern-body {
        padding: 32px 40px;
        display: flex;
        flex-direction: column;
        gap: 28px;
    }

    .formulario-orientacao-fields {
        border: 0;
        margin: 0;
        padding: 0;
        min-width: 0;
    }

    .formulario-orientacao--travado .formulario-orientacao-fields {
        opacity: 0.55;
        pointer-events: none;
        user-select: none;
    }

    .formulario-orientacao-hint {
        margin: 12px 0 4px;
        padding: 12px 14px;
        border-radius: 10px;
        background: #eff6ff;
        border: 1px solid #bfdbfe;
        color: #1e40af;
        font-size: 13px;
        font-weight: 500;
        line-height: 1.45;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 1px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 14px;
        letter-spacing: 0.2px;
        margin-bottom: 4px;
        margin-top: 10px;
        line-height: 1.5;
    }

    .tipo-pergunta-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 16px;
        margin-top: 8px;
    }

    .tipo-pergunta-card {
        padding: 24px 20px;
        border: 2px solid #e5e7eb;
        border-radius: 14px;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        text-align: center;
        background: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        position: relative;
        overflow: hidden;
    }

        .tipo-pergunta-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: linear-gradient(90deg, #2563eb, #1d4ed8);
            transform: scaleX(0);
            transition: transform 0.3s ease;
        }

        .tipo-pergunta-card:hover {
            border-color: #2563eb;
            transform: translateY(-3px);
            box-shadow: 0 8px 20px rgba(37, 99, 235, 0.2);
        }

            .tipo-pergunta-card:hover::before {
                transform: scaleX(1);
            }

        .tipo-pergunta-card.selected {
            border-color: #2563eb;
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            box-shadow: 0 6px 16px rgba(37, 99, 235, 0.25);
        }

            .tipo-pergunta-card.selected::before {
                transform: scaleX(1);
            }

    .tipo-pergunta-card i {
        font-size: 32px;
        color: #2563eb;
        margin-bottom: 4px;
        transition: all 0.3s ease;
    }

    .tipo-pergunta-card.selected i {
        color: #1d4ed8;
        transform: scale(1.1);
    }

    .tipo-nome {
        display: block;
        font-size: 15px;
        font-weight: 700;
        color: #1f2937;
        line-height: 1.4;
    }

    .tipo-prazo {
        display: block;
        font-size: 13px;
        font-weight: 500;
        color: #6b7280;
        line-height: 1.3;
    }

    .tipo-pergunta-card.selected .tipo-nome {
        color: #1e40af;
    }

    .tipo-pergunta-card.selected .tipo-prazo {
        color: #3b82f6;
    }

    .mensagem-tipo {
        margin-top: 8px;
    }

    .mensagem-aviso {
        padding: 14px 18px;
        border-radius: 12px;
        font-size: 13px;
        line-height: 1.6;
        background: rgba(37, 99, 235, 0.1);
        color: #1e3a8a;
        border-left: 4px solid #2563eb;
        margin-top: 8px;
    }

    .modern-modal .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.3);
        background: #ffffff;
        padding: 14px 18px;
        font-size: 15px;
        color: #1f2937;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        font-family: inherit;
    }

        .modern-modal .form-control::placeholder {
            color: #9ca3af;
            font-weight: 400;
        }

        .modern-modal .form-control:focus {
            border-color: #2563eb;
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
            background: #ffffff;
            outline: none;
        }

        .modern-modal .form-control:hover:not(:focus) {
            border-color: rgba(148, 163, 184, 0.5);
        }

    .form-textarea {
        min-height: 140px;
        resize: vertical;
        line-height: 1.6;
    }

    .textarea-com-contador {
        position: relative;
    }

        .textarea-com-contador .form-textarea {
            padding-bottom: 28px;
        }

        .textarea-com-contador .form-textarea--excedido {
            border-color: #ef4444;
        }

            .textarea-com-contador .form-textarea--excedido:focus {
                border-color: #ef4444;
                box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
            }

    .char-counter {
        position: absolute;
        right: 12px;
        bottom: 10px;
        pointer-events: none;
        line-height: 1;
    }

    .char-count-text {
        font-size: 11px;
        color: #94a3b8;
        font-weight: 500;
        letter-spacing: 0.2px;
    }

        .char-count-text--excedido {
            color: #ef4444;
            font-weight: 700;
        }

    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-modern-primary {
        border: none;
        border-radius: 12px;
        padding: 14px 20px;
        font-weight: 700;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        color: white;
    }

        .btn-modern-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
        }

        .btn-modern-primary:active {
            transform: translateY(0);
        }

        .btn-modern-primary:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            transform: none !important;
        }

    /* Dark Mode */
    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.92) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

        [data-bs-theme="dark"] .btn-close-modern svg {
            color: #e2e8f0;
        }

    [data-bs-theme="dark"] .char-count-text {
        color: #64748b;
    }

    [data-bs-theme="dark"] .char-count-text--excedido {
        color: #f87171;
    }

    [data-bs-theme="dark"] .textarea-com-contador .form-textarea--excedido {
        border-color: #f87171;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

        [data-bs-theme="dark"] .modern-modal .form-control:focus {
            background: rgba(15, 23, 42, 0.95);
        }

    [data-bs-theme="dark"] .modern-modal .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .tipo-pergunta-card {
        background: #1f2937;
        border-color: #374151;
    }

        [data-bs-theme="dark"] .tipo-pergunta-card:hover {
            border-color: #3b82f6;
            box-shadow: 0 8px 20px rgba(59, 130, 246, 0.25);
        }

        [data-bs-theme="dark"] .tipo-pergunta-card.selected {
            background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
            box-shadow: 0 6px 16px rgba(59, 130, 246, 0.3);
        }

    [data-bs-theme="dark"] .tipo-pergunta-card i {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .tipo-pergunta-card.selected i {
        color: #3b82f6;
    }

    [data-bs-theme="dark"] .tipo-nome {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .tipo-prazo {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .tipo-pergunta-card.selected .tipo-nome {
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .tipo-pergunta-card.selected .tipo-prazo {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .formulario-orientacao-hint {
        background: rgba(37, 99, 235, 0.18);
        border-color: rgba(59, 130, 246, 0.35);
        color: #93c5fd;
    }

    [data-bs-theme="dark"] .mensagem-aviso {
        background: rgba(37, 99, 235, 0.18);
        color: #cbd5f5;
        border-left-color: #3b82f6;
    }

    [data-bs-theme="dark"] .modern-modal .form-control::placeholder {
        color: #64748b;
    }

    [data-bs-theme="dark"] .modern-modal .form-control:hover:not(:focus) {
        border-color: rgba(148, 163, 184, 0.4);
    }

    [data-bs-theme="dark"] .btn-modern-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

    /* Responsive */
    @media (max-width: 768px) {
        .modern-header {
            padding: 24px 0;
        }

        .header-content {
            flex-direction: column;
            text-align: left;
            gap: 20px;
        }

        .title-section {
            width: 100%;
            max-width: 100%;
            margin-left: 0;
        }

        .modern-title {
            font-size: 28px;
        }

        .modern-subtitle {
            font-size: 13px;
        }

        .usage-badge {
            width: 100%;
        }

        .custom-table-header {
            flex-direction: column;
            align-items: stretch;
        }

        .search-box {
            width: 100%;
        }

        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-body {
            gap: 24px;
        }

        .form-group {
            gap: 10px;
        }

        .tipo-pergunta-grid {
            grid-template-columns: 1fr;
            gap: 12px;
        }

        .tipo-pergunta-card {
            padding: 20px 16px;
        }
    }


    :deep(.btn-manual-tool) {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        min-height: 42px;
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important;
        color: #fff !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    :deep(.btn-manual-tool:hover) {
        background: linear-gradient(135deg, #4b5563 0%, #374151 100%) !important;
        transform: translateY(-2px);
    }
</style>